import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['form', 'saveButton', 'container']

  initialize() {
    this.originalFormTarget = this.formTarget.action
  }

  changeSelection(event) {
    this.formTarget.action = event.target.dataset.path
  }

  saveButtonClick(event) {
    event.preventDefault()

    const $ = jquery()
    if (this.formTarget.action === this.originalFormTarget) {
      if ($) {
        $.modal.close()
      }
    } else {
      if ($) {
        $(event.target).addClass('disabled').text('Saving ...')
      }
      Rails.fire(this.formTarget, 'submit')
    }
  }

  success() {
    const container = this.containerTarget
    container.parentElement.removeChild(container)

    const $ = jquery()
    if ($) {
      $.modal.close()
    }
  }
}
